import { ethers } from "ethers";
import queryString from "query-string";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useNetwork } from "wagmi";
import { Context } from "../context/context";
import { DEFAULT_CHAIN, SUPPORTED_CHAIN, contract } from "../hooks/constant";
import gldnTextImg from "../images/gldn-logotype.png";
import {
  default as lconImg,
  default as lconLight,
  default as logoImg,
  default as logoLight,
} from "../images/logo.png";
import Connect from "./Connect";
import ConfettiLinear from "./IconConfetti";

export default function Header() {
  const { darkMode } = useContext(Context);
  const router = useRouter();
  const { chain } = useNetwork();
  const [web3, setWeb3] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    // Check if MetaMask is installed and enabled
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      setWeb3(provider);
    }

    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup function to remove event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  const switchNetwork = async (network) => {
    if (!web3) {
      console.error("Web3 not initialized.");
      return;
    }

    try {
      await web3.send("wallet_switchEthereumChain", [
        { chainId: "0x" + network.toString(16) },
      ]);
      // Perform additional tasks if needed after switching the network
      console.log(`Switched to network ${network}`);
    } catch (error) {
      console.error("Error switching network:", error);
      // If the error indicates that the network is not available, try adding it
      if (error.code === 4902) {
        try {
          await web3.send("wallet_addEthereumChain", [
            {
              chainId: "0x" + network.toString(16),
              chainName: contract[network]
                ? contract[network].name
                : contract[DEFAULT_CHAIN].name, // Replace with your network name
              nativeCurrency: {
                name: contract[network]
                  ? contract[network].symbol
                  : contract[DEFAULT_CHAIN].symbol,
                symbol: contract[network]
                  ? contract[network].symbol
                  : contract[DEFAULT_CHAIN].name,
                decimals: 18,
              },
              rpcUrls: [
                contract[network]
                  ? contract[network].rpc
                  : contract[DEFAULT_CHAIN].rpc,
              ], // Replace with your RPC endpoint
            },
          ]);
          console.log(`Added network ${network}`);
          // Retry switching network after adding it
          await switchNetwork(network);
        } catch (addError) {
          console.error("Error adding network:", addError);
        }
      }
    }
  };

  return (
    <React.Fragment>
      <div className="main-header side-header sticky">
        <div className="main-container container-fluid">
          <div className="main-header-left">
            <a
              className="main-header-menu-icon"
              href="#sec"
              id="mainSidebarToggle"
            >
              <span></span>
            </a>
            <div className="hor-logo">
              <Link className="main-logo" to="/">
                <img
                  src={logoImg}
                  className="header-brand-img desktop-logo"
                  height="37px"
                  width="100px"
                  alt="logo"
                />
                <img
                  src={logoLight}
                  className="header-brand-img desktop-logo-dark"
                  alt="logo"
                  height="37px"
                  width="134px"
                />
                <img
                  src={gldnTextImg}
                  className="header-brand-img"
                  alt="logo"
                  height="37px"
                  width="100px"
                />
              </Link>
            </div>
          </div>
          <div className="main-header-center">
            <div className="responsive-logo">
              {darkMode ? (
                <Link to="/">
                  <div className="d-flex justify-content-center align-items-center">
                    <img
                      src={logoLight}
                      className="mobile-logo"
                      alt="logo"
                      style={{ height: "30px" }}
                    />
                    <p className="mx-2 text-white desktop-logo m-0">
                      LockChain
                    </p>
                  </div>
                </Link>
              ) : (
                <Link to="/">
                  <img
                    src={logoImg}
                    className="mobile-logo"
                    alt="logo"
                    style={{ height: "30px" }}
                  />
                  <p className="mx-2 text-white desktop-logo m-0">LockChain</p>
                </Link>
              )}
            </div>
          </div>
          <div className="main-header-right">
            <button
              className="navbar-toggler navresponsive-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent-4"
              aria-controls="navbarSupportedContent-4"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="fe fe-more-vertical header-icons navbar-toggler-icon"></i>
            </button>
            <div className="navbar navbar-expand-lg  nav nav-item  navbar-nav-right responsive-navbar navbar-dark  ">
              <div
                class="header-element ms-3 d-lg-block d-none my-auto mx-3"
                ref={dropdownRef}
              >
                <div class="dropdown my-auto">
                  {chain && chain.id && SUPPORTED_CHAIN.includes(chain.id) ? (
                    <a
                      onClick={() => setDropdownOpen(!dropdownOpen)}
                      aria-label="anchor"
                      href="#sec"
                      class="btn ripple btn-primary text-white btn-rounded header-dashboards-button text-start d-flex align-items-center justify-content-between show"
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                    >
                      <img
                        height="24px"
                        width="24px"
                        src={contract[chain.id].img}
                        alt={contract[chain.id].symbol}
                      />
                      <span className="mx-2">{contract[chain.id].name}</span>
                    </a>
                  ) : (
                    <a
                      onClick={() => setDropdownOpen(!dropdownOpen)}
                      aria-label="anchor"
                      href="#sec"
                      class="btn ripple btn-primary btn-rounded header-dashboards-button text-start d-flex align-items-center justify-content-between show"
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                    >
                      <img
                        height="24px"
                        width="24px"
                        src={contract[DEFAULT_CHAIN].img}
                        alt={contract[DEFAULT_CHAIN].symbol}
                      />
                      {contract[DEFAULT_CHAIN].name}
                      <i class="ri-arrow-down-s-line align-middle ms-1 d-inline-block float-end"></i>
                    </a>
                  )}
                  <ul
                    class={`dropdown-menu dashboard-dropdown ${
                      dropdownOpen ? "show" : "none"
                    }`}
                    role="menu"
                    style={{
                      position: "absolute",
                      inset: "0px auto auto 0px",
                      margin: "0px",
                      transform: "translate3d(0px, 40.5px, 0px)",
                    }}
                    data-popper-placement="bottom-start"
                  >
                    {SUPPORTED_CHAIN &&
                      SUPPORTED_CHAIN.map((row, key) => {
                        return (
                          contract[row] && (
                            <li key={key} onClick={() => switchNetwork(row)}>
                              <a
                                class="dropdown-item dashboards-dropdown-item text-white"
                                href="#sec"
                              >
                                <img
                                  height="24px"
                                  width="24px"
                                  src={contract[row].img}
                                  alt={contract[row].symbol}
                                />{" "}
                                {contract[row].name}
                              </a>
                            </li>
                          )
                        );
                      })}
                  </ul>
                </div>
              </div>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent-4"
              >
                <div className="d-flex order-lg-2 ms-auto justify-content-end">
                  <div className="dropdown">
                    <Connect />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="sticky"
        style={{
          background:
            "radial-gradient(at 53% 34%, rgba(0, 128, 0, 0.3) -84%, #141414 63%)",
        }}
      >
        <div
          className="main-menu main-sidebar main-sidebar-sticky side-menu is-expanded ps ps--active-y "
          style={{
            background:
              "radial-gradient(at 53% 34%, #1253ff -84%, #141414 63%)",
            backdropFilter: "blur(1px)",
          }}
        >
          <div className="main-sidebar-header main-container-1 active">
            <div className="sidemenu-logo">
              <Link className="main-logo" to="/">
                <div className="d-flex align-items-center">
                  <img
                    src={logoLight}
                    className="header-brand-img desktop-logo ml-4"
                    alt="logo"
                    height="40px"
                    width="100px"
                  />
                  <p className="mx-2 text-white desktop-logo m-0 fs-25">
                    LOCKCHAIN
                  </p>
                </div>
                <img
                  src={lconLight}
                  className="header-brand-img icon-logo"
                  alt="logo"
                  height="40px"
                />
                <img
                  src={logoImg}
                  className="header-brand-img desktop-logo theme-logo"
                  alt="logo"
                  height="40px"
                  width="100px"
                />
                <img
                  src={lconImg}
                  className="header-brand-img icon-logo theme-logo"
                  alt="logo"
                />
              </Link>
            </div>
            <div className="main-sidebar-body main-body-1">
              <div
                className="slide-left disabled active d-none"
                id="slide-left"
              >
                <i className="fe fe-chevron-left"></i>
              </div>
              <ul className="menu-nav nav">
                <li className="nav-header active">
                  <span className="nav-label">Dashboard</span>
                </li>
                <li
                  className={`nav-item  ${
                    router.pathname === "/" ? "active" : ""
                  }`}
                >
                  <Link className="nav-link" to="/">
                    <i className="ti-home sidemenu-icon menu-icon "></i>
                    <span className="sidemenu-label">Dashboard</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </Link>
                </li>
                <li className="nav-header active">
                  <span className="nav-label">Account</span>
                </li>
                <li
                  className={`nav-item  ${
                    router.pathname === "/account" ? "active" : ""
                  }`}
                >
                  <Link className="nav-link" to="/account">
                    <i className="ti-user sidemenu-icon menu-icon "></i>
                    <span className="sidemenu-label">Account</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </Link>
                </li>

                <li className="nav-header active">
                  <span className="nav-label">Swap</span>
                </li>
                <li
                  className={`nav-item ${
                    router.pathname === "/swap" ? "active" : ""
                  }`}
                >
                  <Link className="nav-link" to="/swap">
                    <i className="si si-layers sidemenu-icon menu-icon "></i>
                    <span className="sidemenu-label">LockSwap</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </Link>
                </li>
                <li className="nav-header active">
                  <span className="nav-label">Chart & Docs</span>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    rel="noreferrer"
                    target="_blank"
                    href=" https://grass-3.gitbook.io/lockchain-whitepaper"
                  >
                    <i className="ti-receipt sidemenu-icon menu-icon"></i>
                    <span className="sidemenu-label">Whitepaper</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </a>
                </li>
                {/* <li className="nav-item">
                  <a
                    className="nav-link"
                    rel="noreferrer"
                    target="_blank"
                    href={SIDEBAR_TOKEN_LINK}
                  >
                    <i className="ti-receipt sidemenu-icon menu-icon"></i>
                    <span className="sidemenu-label">LockChain Contract</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    rel="noreferrer"
                    target="_blank"
                    href={SIDEBAR_CHART_LINK}
                  >
                    <i className="ti-receipt sidemenu-icon menu-icon"></i>
                    <span className="sidemenu-label">LockChain Chart</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </a>
                </li> */}
                <li className="nav-header active">
                  <span className="nav-label">Socials</span>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    rel="noreferrer"
                    target="_blank"
                    href="https://t.me/lockchainportal"
                  >
                    <i className="si si-paper-plane sidemenu-icon menu-icon"></i>
                    <span className="sidemenu-label">Telegram</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://x.com/LockChainAi">
                    <svg
                      style={{ height: "20px", width: "34px" }}
                      fill="#fff6"
                      className="sidemenu-icon menu-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                    </svg>
                    <span className="sidemenu-label">X</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </a>
                </li>
                <li className="nav-header active">
                  <span className="nav-label">Give away</span>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/tickets">
                    <ConfettiLinear />
                    <span className="sidemenu-label">Claim Airdrop</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </Link>
                </li>
                {/* <li className="nav-item">
                                    <a className="nav-link" target="_self" href="hmailto:water@bluarctic.xyz">
                                        <span className="shape1"></span>
                                        <span className="shape2"></span>
                                        <i className="si si-envelope-open sidemenu-icon menu-icon"></i>
                                        <span className="sidemenu-label">Email</span>
                                        <i className="angle fe fe-chevron-right"></i>
                                    </a>
                                </li> */}
              </ul>
              <div className="slide-right" id="slide-right">
                <i className="fe fe-chevron-right"></i>
              </div>
            </div>
          </div>
          <div className="ps__rail-x" style={{ left: "0px", top: "0px" }}>
            <div
              className="ps__thumb-x"
              tabIndex="0"
              style={{ left: "0px", width: "0px" }}
            ></div>
          </div>
          <div
            className="ps__rail-y"
            style={{ top: "0px", height: "269px", right: "0px" }}
          >
            <div
              className="ps__thumb-y"
              tabIndex="0"
              style={{ top: "0px", height: "77px" }}
            ></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export function useRouter() {
  const params = useParams();
  const location = useLocation();

  // Return our custom router object
  // Memoize so that a new object is only returned if something changes
  return useMemo(() => {
    return {
      // For convenience add push(), replace(), pathname at top level
      push: location.push,
      replace: location.replace,
      pathname: location.pathname,
      // Merge params and parsed query string into single "query" object
      // so that they can be used interchangeably.
      // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
      query: {
        ...queryString.parse(location.search), // Convert string to object
        ...params,
      },
      // Include match, location, history objects so we have
      // access to extra React Router functionality if needed.
      location,
    };
  }, [params, location]);
}
